exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iconComponent {\n  display: inline;\n  padding: 0 0.5em;\n}\n.iconComponent-actionIcon {\n  transition: -webkit-transform .4s;\n  transition: transform .4s;\n  transition: transform .4s, -webkit-transform .4s;\n  cursor: pointer;\n}\n.iconComponent-actionIcon:hover {\n  -webkit-transform: scale(1.3);\n          transform: scale(1.3);\n  color: #6236ff;\n}\n.iconComponent-noActionIcon {\n  cursor: pointer;\n}\n", ""]);

// exports
